module.exports = __webpack_public_path__ + "static/img/p1_img1.055fa17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1_img1.png
// module id = A8NQ
// module chunks = 0